import React from 'react'
import { StyledEngineProvider } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/core/styles';

import Routes from './Routes'
import Theme from '../assets/theme'
import { FeedbackButton } from '../components/Atoms'
import { DisclaimerList } from '../components/Molecules'
import { ErrorBoundary } from '../components/Pages'
import { UrlManipulation } from '../utils'


const App = () => {
  React.useEffect(() => {
    UrlManipulation.updateTitle()
  }, [])

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={Theme}>
        <React.Suspense fallback={<CircularProgress style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        }} />}>
          <ErrorBoundary>
            <Routes />
            <FeedbackButton />
            <DisclaimerList />
          </ErrorBoundary>
        </React.Suspense>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default App
